import React, { useEffect } from 'react'
import ModalCustom from '../../../modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import {
  deleteFactionsAPI,
  updateFactionsAPI
} from '../../../../services/factions'
import LabelCustom from '../../../label-custom'
import Error_false from '../../../error/error-false'
import Swal from 'sweetalert2'
import SwalCustom from '../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../Constants'
const schema = yup
  .object({
    faction: yup.string().required('Please, Input character of Division'),
    factionEn: yup.string().required('Please, Input Division for English'),
    factionTh: yup.string().required('Please, Input Division for Thai')
  })
  .required()
export default function EditFaction({
  setIsSave,
  showCreate,
  isSave,
  setShowCreate,
  detail,
  divisionId,
  orgId,
  setIsRefresh,
  handleKeyDownTH,
  handleKeyDownEN,
  handleKeyDownNum
}) {
  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  useEffect(() => {
    setValue('faction', detail.faction ?? '')
    setError('faction', false)

    setValue('factionEn', detail.faction_en ?? '')
    setError('factionEn', false)

    setValue('factionTh', detail.faction_th ?? '')
    setError('factionTh', false)
    setValue('larkEnable', detail?.lark_enable ?? false)
  }, [
    detail.faction,
    detail.faction_en,
    detail.faction_th,
    detail?.lark_enable,
    setError,
    setValue
  ])

  //update function
  const onSubmit = (body) => {
    const param = { factionId: detail.id, divisionId, orgId }
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to save the changes?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        updateFaction(body, param)
      }
    })
  }

  const updateFaction = async (body, param) => {
    const results = await updateFactionsAPI(param, {
      ...body,
      larkEnable: body.larkEnable ?? false
    })
    if (!results) {
      setIsSave(false)
      return
    }
    if (results.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        setIsRefresh(true)
        setShowCreate(false)
        Swal.close()
      })
    } else {
      Error_false(results)
    }
    setIsSave(false)
    fnReset()
  }

  const fnReset = () => {
    setError('faction', false)
    setError('factionEn', false)
    setError('factionTh', false)
  }

  const handleClose = () => {
    setShowCreate(false)
    fnReset()
  }

  const handleOnDelete = (result) => {
    const param = { factionId: detail.id, orgId: orgId }

    SwalCustom({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          const results = await deleteFactionsAPI(param)
          if (results.status) {
            setShowCreate(false)
          }
          Swal.fire('Deleted!', 'Your file has been deleted.', 'success')
        }
      })
      .then(() => {
        setIsRefresh(true)
      })
  }

  return (
    <ModalCustom width={500} open={showCreate} onCancel={handleClose}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <label className="text-primary">Update Division</label>
        <Col md={12}>
          <LabelCustom text={'Division'} />
          <Controller
            name={'faction'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={2}
                value={value}
                onChange={onChange}
                onKeyDown={handleKeyDownEN}
              />
            )}
          />
          {errors.faction?.message && (
            <label className="small text-danger">
              {errors.faction.message}
            </label>
          )}
        </Col>
        <Col md={12}>
          <LabelCustom text={'Division EN'} />
          <Controller
            name={'factionEn'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={100}
                value={value}
                onChange={onChange}
                // onKeyDown={handleKeyDownEN}
              />
            )}
          />
          {errors.factionEn?.message && (
            <label className="small text-danger">
              {errors.factionEn.message}
            </label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Division TH'} />
          <Controller
            name={'factionTh'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={100}
                value={value}
                onChange={onChange}
                // onKeyDown={handleKeyDownTH}
              />
            )}
          />
          {errors.factionTh?.message && (
            <label className="small text-danger">
              {errors.factionTh.message}
            </label>
          )}
        </Col>
        <Col md={12}>
          <Controller
            name={'larkEnable'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Group
                className="mb-3"
                controlId="formBasicCheckbox"
                value={value}
                onChange={onChange}
              >
                <Form.Check
                  checked={value}
                  type="checkbox"
                  label="Lark Enable"
                />
              </Form.Group>
            )}
          />
        </Col>

        <Col xl={12} className="text-center ">
          {detail.count_emp === 0 && (
            <Button
              // data={orgId}
              className="px-4 me-2 bg-danger text-white"
              variant="light"
              type="button"
              disabled={isSave}
              onClick={handleOnDelete}
            >
              Delete
            </Button>
          )}
          <Button
            className="px-4 "
            disabled={isSave}
            type="submit"
            // onClick={onSubmit}
          >
            {isSave ? 'Saving...' : 'Save'}
          </Button>
        </Col>
      </Form>
    </ModalCustom>
  )
}
